import './Discussions.scss';
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import AuthContext from "../../context/AuthContext";
import SnackbarContext from "../../context/SnackbarContext";
import { authHeaders } from '../../utils/api';
import { API_BASE_URL } from '../../config';


export default function NewDiscussion() {
    const navigate = useNavigate();
    const { authTokens } = useContext(AuthContext);
    const { setSnackbar } = useContext(SnackbarContext);
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!title.trim() || !body.trim()) return;
        setSubmitting(true);
        try {
            const r = await fetch(`${API_BASE_URL}/api/discussions/topics/`, {
                method: 'POST',
                headers: { ...authHeaders(authTokens), 'Content-Type': 'application/json' },
                body: JSON.stringify({ title, body }),
            });
            const data = await r.json().catch(() => ({}));
            if (!r.ok) {
                setSnackbar({
                    content: data?.title?.[0] || data?.body?.[0] || data?.detail || 'تعذر إنشاء الموضوع',
                    success: false,
                });
                return;
            }
            setSnackbar({ content: 'تم نشر الموضوع', success: true });
            navigate(`/discussions/${data.id}`);
        } catch {
            setSnackbar({ content: 'تعذر إنشاء الموضوع', success: false });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
        <Navbar />
        <main className='disc-page'>
            <div className='disc-container'>
                <Link to='/discussions' className='disc-back'>العودة إلى النقاشات</Link>
                <header className='disc-header'>
                    <div>
                        <h1>موضوع جديد</h1>
                        <p>اكتب عنوانًا واضحًا ونصًّا يفتح النقاش.</p>
                    </div>
                </header>

                <form className='disc-form' onSubmit={onSubmit}>
                    <label>
                        <span>العنوان</span>
                        <input
                            type='text'
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            maxLength={200}
                            placeholder='عن ماذا تريد أن تتحدث؟'
                            required
                        />
                    </label>
                    <label>
                        <span>نص الموضوع</span>
                        <textarea
                            rows={8}
                            maxLength={10000}
                            value={body}
                            onChange={(e) => setBody(e.target.value)}
                            placeholder='افتح النقاش بمشاركة فكرتك أو سؤالك…'
                            required
                        />
                    </label>
                    <div className='disc-form-actions'>
                        <button
                            type='submit'
                            className='disc-button'
                            disabled={submitting || !title.trim() || !body.trim()}
                        >
                            {submitting ? 'جارٍ النشر…' : 'نشر الموضوع'}
                        </button>
                    </div>
                </form>
            </div>
        </main>
        <Footer />
        </>
    );
}
